import React from 'react'
import { Container } from '@sencha/ext-modern'

export default props => {
	const { text, subtext } = props
	return <Container fullScreen layout={{ type: 'vbox', align: 'center' }} padding={10}>
		<h2>{text}</h2>
		{subtext && <h6>{subtext}</h6>}
	</Container>
}